export default __webpack_public_path__ + "static/media/rain.a7a5287e.png";